import { render, staticRenderFns } from "./ManageCommunityOptions.vue?vue&type=template&id=ea892756&"
import script from "./ManageCommunityOptions.vue?vue&type=script&lang=js&"
export * from "./ManageCommunityOptions.vue?vue&type=script&lang=js&"
import style0 from "./ManageCommunityOptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports